import { useEffect, useState } from "react";

export const ADMIN_TOKEN_KEY = "xr_admin_token";
export const ADMIN_CHANGE_EVENT = "xr-admin-change";

export const getAdminToken = () => {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  } catch (e) {
    return "";
  }
};

export const setAdminToken = (token) => {
  try {
    if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch (e) {}
  // Notify same-tab listeners (the native `storage` event only fires cross-tab).
  window.dispatchEvent(new Event(ADMIN_CHANGE_EVENT));
};

export const useAdminMode = () => {
  const [on, setOn] = useState(() => !!getAdminToken());
  useEffect(() => {
    const update = () => setOn(!!getAdminToken());
    window.addEventListener("storage", update);
    window.addEventListener(ADMIN_CHANGE_EVENT, update);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener(ADMIN_CHANGE_EVENT, update);
    };
  }, []);
  return on;
};
